module.exports = __webpack_public_path__ + "static/media/daniel-bettamio-tesser.22a535ac.png";